import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    constructor(private router: Router) { }

    private go(url: string | any[], data?: any) {

        const extras: NavigationExtras | undefined =
            data ? { state: data } : undefined;

        const target = Array.isArray(url) ? url : [url];

        this.router.navigate(target, {
            ...extras,
            replaceUrl: false
        });

    }

    // ===============================
    // MAIN TABS
    // ===============================

    home(data?: any) {
        this.go('/tabs/home', data);
    }

    appointment(data?: any) {
        this.go('/tabs/appointment', data);
    }

    nearby() {
        this.go('/tabs/nearby');
    }

    notification() {
        this.go('/tabs/notification');
    }

    profile() {
        this.go('/tabs/profile');
    }

    // ===============================
    // AUTH
    // ===============================

    login() {
        this.go('/login-signup');
    }

    signup() {
        this.go('/signup');
    }

    forgotPassword() {
        this.go('/forgot');
    }

    verifyOtp(data?: any) {
        this.go('/verify', data);
    }

    verifyEmail(data?: any) {
        this.go('/verify-email', data);
    }

    // ===============================
    // HOME FLOW
    // ===============================

    search(data?: any) {
        this.go('/home/search', data);
    }

    topServices(data?: any) {
        this.go('/home/tops', data);
    }

    salonProfile(data?: any) {
        this.go('/home/salon-profile', data);
    }

    allSalons(data?: any) {
        this.go('/home/all-salons', data);
    }

    offers(data?: any) {
        this.go('/home/offers', data);
    }

    selectService(data?: any) {
        this.go('/home/service', data);
    }

    // ===============================
    // BOOKING FLOW
    // ===============================

    selectTimeSlot(data?: any) {
        this.go('/home/select-time-slot', data);
    }

    makePayment(data?: any) {
        this.go('/home/makepayment', data);
    }

    singleAppointment(id: number) {
        this.go(['/appointment/single-appointment', id]);
    }

    // ===============================
    // LOCATION
    // ===============================

    setLocation() {
        this.go('/nearby/setlocatio');
    }

    confirmLocation(data?: any) {
        this.go('/confirmlocation', data);
    }

    locationSettings() {
        this.go('/location-settings');
    }

    // ===============================
    // PROFILE
    // ===============================

    editProfile() {
        this.go('/profile/edit');
    }

    wallet() {
        this.go('/profile/wallet');
    }

    addresses() {
        this.go('/profile/addresses');
    }

    addAddress() {
        this.go('/profile/add-address');
    }

    referAndEarn() {
        this.go('/profile/refer-and-earn');
    }

    // ===============================
    // SUPPORT
    // ===============================

    contactUs() {
        this.go('/support/contact-us');
    }

    submitRequest() {
        this.go('/support/submit-request');
    }

    supportTickets() {
        this.go('/support/support-tickets');
    }

    // ===============================
    // LEGAL
    // ===============================

    privacyPolicy() {
        this.go('/legal/privacy-policy');
    }

    terms() {
        this.go('/legal/terms');
    }

    refundPolicy() {
        this.go('/legal/refund-policy');
    }

    // ===============================
    // BLOG
    // ===============================

    blog() {
        this.go('/blog');
    }

    blogDetail(slug: string) {
        this.go(['/blog', slug]);
    }

    // ===============================
    // SETTINGS
    // ===============================

    appSettings() {
        this.go('/settings/app-settings');
    }

    // ===============================
    // EXTRA
    // ===============================

    searchResult(data?: any) {
        this.go('/searchresult', data);
    }

}